module.exports = __webpack_public_path__ + "static/media/10.9e55bcd0.jpeg";